import { defineMessages } from 'react-intl';

export default defineMessages({
  tooltipDisabled: {
    id: 'App.RentForecast.DeleteForecast.Tooltip.Label',
    defaultMessage: 'You do not have permission to perform this action',
  },
  button: {
    id: 'App.RentForecast.DeleteForecast.Button.Label',
    defaultMessage: 'Delete Record',
  },
  modalBody: {
    id: 'App.RentForecast.DeleteForecast.Modal.Body',
    defaultMessage:
      "You are about to delete the record '<strong>'{forecastName}'</strong>'. " +
      'This action can not be undone. Are you sure you want to proceed?',
  },
  modalTitle: {
    id: 'App.RentForecast.DeleteForecast.Modal.Title',
    defaultMessage: 'Delete Forecast Rent Record',
  },
  modalButtonCancel: {
    id: 'App.RentForecast.DeleteForecast.Modal.Action.Cancel.Label',
    defaultMessage: 'Cancel',
  },
  modalButtonConfirm: {
    id: 'App.RentForecast.DeleteForecast.Modal.Action.Confirm.Label',
    defaultMessage: 'Confirm & Delete',
  },
  modalButtonConfirmApprovals: {
    id: 'App.RentForecast.DeleteForecast.Modal.Action.Confirm.Approval.Tooltip',
    defaultMessage:
      'Approved record(s) from this forecast are still present. Delete approved record(s) first.',
  },
  resultSuccess: {
    id: 'App.RentForecast.DeleteForecast.Modal.Result.Success',
    defaultMessage: 'The record {forecastName} has been successfully deleted',
  },
  resultFail: {
    id: 'App.RentForecast.DeleteForecast.Modal.Result.Fail',
    defaultMessage:
      'Could not delete rent forecast record. Please try again later.',
  },
  resultNoPermission: {
    id: 'App.RentForecast.DeleteForecast.Modal.Result.NoPermission',
    defaultMessage:
      'Cannot delete rent forecast record. Insufficient permission.',
  },
  resultConflict: {
    id: 'App.RentForecast.DeleteForecast.Modal.Result.Conflict',
    defaultMessage: 'Cannot delete rent forecast record. Conflict: {conflict}',
  },
});
